module.exports = __webpack_public_path__ + "static/media/zglos.148ed86c.svg";